export default "__VITE_ASSET__DqcIRpuL__"